import { useEffect, useState } from 'react';
import moment from 'moment';

//* Components
import Text from 'components/common/Text';

const Clock = () => {
	const [time, setTime] = useState(moment().format('h:mm:ss a'));

	useEffect(() => {
		const interval = setInterval(() => {
			setTime(moment().format('h:mm:ss a'));
		}, 1000);

		return () => clearInterval(interval);
	}, []);

	return (
		<Text
			className={'uppercase p font-ping-medium weather-clock'}
			text={time}
		/>
	);
};

export default Clock;
